import { isValidPulseTemplate } from './PulseTemplate';
const triggerApiToEntity = t => ({
  type: t == null ? void 0 : t.type,
  triggerKey: t == null ? void 0 : t.triggerKey
});
const triggerEntityToApi = t => ({
  type: t == null ? void 0 : t.type,
  triggerKey: t == null ? void 0 : t.triggerKey
});
export const pulseTemplateApiToEntity = pulseTemplate => {
  var _pulseTemplate$trigge;
  if (!(pulseTemplate != null && pulseTemplate.id) || pulseTemplate.revision === undefined || pulseTemplate.revision === null) {
    throw new Error('Invalid pulse template', {
      cause: {
        pulseTemplate
      }
    });
  }
  const converted = {
    id: pulseTemplate.id,
    revision: String(pulseTemplate.revision),
    createdDate: pulseTemplate.createdDate ? new Date(pulseTemplate.createdDate) : undefined,
    updatedDate: pulseTemplate.updatedDate ? new Date(pulseTemplate.updatedDate) : undefined,
    nameTranslations: pulseTemplate.nameTranslations,
    descriptionTranslations: pulseTemplate.descriptionTranslations,
    soul: pulseTemplate.soul,
    heartbeat: pulseTemplate.heartbeat,
    triggers: (_pulseTemplate$trigge = pulseTemplate.triggers) == null ? void 0 : _pulseTemplate$trigge.map(triggerApiToEntity),
    cron: pulseTemplate.cron,
    autoMode: pulseTemplate.autoMode,
    icon: pulseTemplate.icon
  };
  if (isValidPulseTemplate(converted)) {
    return converted;
  }
  throw new Error('Invalid pulse template data', {
    cause: {
      converted
    }
  });
};
export const pulseTemplateEntityToApi = entity => {
  var _entity$triggers;
  return {
    id: entity.id,
    revision: entity.revision,
    nameTranslations: entity.nameTranslations,
    descriptionTranslations: entity.descriptionTranslations,
    soul: entity.soul,
    heartbeat: entity.heartbeat,
    triggers: (_entity$triggers = entity.triggers) == null ? void 0 : _entity$triggers.map(triggerEntityToApi),
    cron: entity.cron,
    autoMode: entity.autoMode,
    icon: entity.icon
  };
};
//# sourceMappingURL=converters.js.map